import ServiceTemplate from '@/components/ServiceTemplate';

export default function AmazonBrandRegistry() {
  const data = {
    title: 'Amazon Brand Registry in the US',
    subtitle: 'Protect your brand on Amazon with Brand Registry enrollment.',
    overviewTitle: 'Why Enroll in Amazon Brand Registry?',
    overviewImage: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3',
    description: [
      'Amazon Brand Registry provides powerful tools to protect and manage your brand on Amazon, including enhanced content, brand analytics, and proactive brand protection features.',
      'To enroll in Brand Registry, you need an active registered trademark. We guide you through the entire process from trademark registration to Brand Registry enrollment.',
      'Our Amazon Brand Registry service ensures your brand is properly protected on the world\'s largest e-commerce platform, giving you control over your product listings and brand presence.'
    ],
    benefits: [
      { title: 'Brand Protection', description: 'Protect against counterfeiters and unauthorized sellers.' },
      { title: 'Enhanced Content', description: 'Access to A+ Content and brand storytelling tools.' },
      { title: 'Brand Analytics', description: 'Detailed insights into customer search and purchase behavior.' },
      { title: 'Sponsored Brands', description: 'Access to advertising features for brand promotion.' },
      { title: 'Listing Control', description: 'Greater control over product detail pages.' },
      { title: 'Trademark Support', description: 'Complete trademark and enrollment assistance.' }
    ],
    process: [
      { title: 'Initial Setup & Assessment', description: 'Comprehensive evaluation of current situation and establishment of service framework.' },
      { title: 'Implementation & Management', description: 'Execute ongoing services with regular monitoring, reporting, and optimization.' },
      { title: 'Review & Strategic Guidance', description: 'Periodic reviews with strategic recommendations for continuous improvement.' }
    ],
    pricing: [
      {
        name: 'Consultation',
        description: 'Initial assessment',
        price: '$299',
        period: 'Per session',
        features: [
          '90-minute consultation',
          'Situation analysis',
          'Strategy recommendations',
          'Action plan',
          'Written summary',
          'Follow-up email support'
        ]
      },
      {
        name: 'Retainer',
        description: 'Ongoing advisory',
        price: '$1,499',
        period: 'Per month',
        featured: true,
        features: [
          'Monthly strategy sessions',
          'Unlimited email support',
          'Priority phone access',
          'Document review',
          'Compliance monitoring',
          'Quarterly reporting',
          'Dedicated attorney'
        ]
      },
      {
        name: 'Project-Based',
        description: 'Custom engagement',
        price: 'Custom',
        period: 'Based on scope',
        features: [
          'Scope-based pricing',
          'Dedicated team',
          'Project management',
          'Milestone deliverables',
          'All work product included',
          'Comprehensive reporting',
          'Executive support'
        ]
      }
    ],
    faqs: [
      { question: 'Do I need a trademark for Brand Registry?', answer: 'Yes, an active registered trademark with the USPTO or other approved national trademark office is required for enrollment.' },
      { question: 'How long does enrollment take?', answer: 'After trademark registration (8-12 months), Brand Registry enrollment typically takes a few days to complete Amazon\'s verification process.' },
      { question: 'What are the benefits of Brand Registry?', answer: 'Benefits include brand protection tools, enhanced content options, brand analytics, sponsored brand ads, automated protections, and improved search functionality.' },
      { question: 'Can I enroll with a pending trademark?', answer: 'No, you need an active registered trademark. Applications can be prepared during trademark prosecution but enrollment requires completed registration.' },
      { question: 'How does Brand Registry protect against counterfeits?', answer: 'Through automated protections, reporting tools, transparency program, and proactive monitoring to identify and remove counterfeit listings.' },
      { question: 'What is Amazon\'s Transparency Program?', answer: 'Anti-counterfeiting service using unique codes on products to verify authenticity, available to Brand Registry participants.' },
      { question: 'Can I have multiple users in Brand Registry?', answer: 'Yes, brand representatives can invite additional users with different permission levels to manage the brand on Amazon.' },
      { question: 'What happens if my trademark expires?', answer: 'Your Brand Registry enrollment will be deactivated if your trademark registration expires or is cancelled. Maintain trademark registration to keep benefits.' }
    ]
  };

  return <ServiceTemplate {...data} />;
}
